<template>
  <div>
    <Headline
      :title="title"
      subtitle="Negocios en movimento"
      image="bookings"
      variant="dark"
    ></Headline>
    <Section image="bookings-1">
      <Card
        title="Una nueva forma de gestionar sus viajes"
        size="lg"
        variant="list"
      >
        <p>Más de 100 empresas utilizan nuestro motor de reservas corporativas, rápido, disponible, que simplifica los procesos y les permite optimizar los gastos de viaje hasta un 20% en el primer año.</p>
        <ul>
          <li>Reservas de vuelos, hoteles y coches de alquiler confirmadas en menos de 3 minutos</li>
          <li>Toda la oferta en una sola pantalla, Low Cost - tarifas públicas y contratadas que permiten hacer una elección más racional</li>
          <li>Visual Guilt - alerta del ahorro perdido cuando no es utilizada la tarifa más económica</li>
          <li>Políticas de viajes y procesos de aprobación integrados</li>
          <li>Aplicación móvil</li>
        </ul>
      </Card>
    </Section>
  </div>
</template>
<script setup>
definePageMeta({
  title: 'Reservas online',
  path: '/productos/reservas-online',
})
const title = useRoute().meta.title
useHead({
  title: `${title} | Geotur`,
})
</script>